import React from "react";
import { useNavigate } from "react-router-dom";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

import { useDeleteCompensationCycle } from "../../../../api/hooks/defs/compensation";

type DeleteCycleModalProps = {
	cycleId: string;
	closeModal: () => void;
};

const DeleteCycleModal: React.FC<DeleteCycleModalProps> = ({ cycleId, closeModal }) => {
	const navigate = useNavigate();
	const { mutate: deleteCycle, isPending } = useDeleteCompensationCycle();

	const handleDeleteCycle = () => {
		deleteCycle(cycleId, {
			onSuccess: () => {
				closeModal();
				navigate("/compensation");
			},
		});
	};

	return (
		<ModalBase isOpen onClose={closeModal} dangerouslySetClassName="!overflow-hidden w-[416px]">
			<div className="flex flex-col items-center px-6 pb-6">
				<div className="flex w-full flex-col items-center text-center">
					<Text size="sub-heading" weight="semi-bold">
						Delete Cycle
					</Text>
					<div className="mx-auto max-w-[384px]">
						<Text size="paragraph-3" weight="regular">
							Are you sure you want to delete this cycle? This action is permanent and cannot be undone.
						</Text>
					</div>
				</div>
				<div className="mt-6 flex flex-row items-center justify-center gap-2">
					<ButtonStandard variant="outline" color="neutral" size="large" onClick={closeModal}>
						Cancel
					</ButtonStandard>
					<ButtonStandard
						variant="solid"
						color="red"
						size="large"
						onClick={handleDeleteCycle}
						disabled={isPending}
					>
						Yes, Delete Cycle
					</ButtonStandard>
				</div>
			</div>
		</ModalBase>
	);
};

export default DeleteCycleModal;
